import { Component, computed, inject, OnInit, output } from '@angular/core';
import { AuthSessionStorage } from '@smata-data-access';
import { AuthStore } from '@smata-login-page';
import { EnvironmentBadgeComponent, MenuProfileComponent } from '@smata-shared';

@Component({
  selector: 'smata-navbar',
  standalone: true,
  imports: [EnvironmentBadgeComponent, MenuProfileComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class SmataNavbarComponent implements OnInit {
  private readonly authStore = inject(AuthStore);
  public logout = output<void>();

  ngOnInit(): void {
    const token = AuthSessionStorage.getToken();
    this.authStore.getCurrentUser(token ?? undefined);
  }
  public userDisplayName = computed(() => this.authStore.userName() ?? '');

  public handleUserLogout(): void {
    this.logout.emit();
  }
}
